export var OvpErrorSource = /*#__PURE__*/ function(OvpErrorSource) {
    OvpErrorSource[OvpErrorSource["PLAYOUT"] = 0] = "PLAYOUT";
    OvpErrorSource[OvpErrorSource["PLAYER"] = 1] = "PLAYER";
    OvpErrorSource[OvpErrorSource["TOKEN_EXCHANGE"] = 2] = "TOKEN_EXCHANGE";
    return OvpErrorSource;
}({});

//# sourceMappingURL=ovp.enums.js.map